import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

// Calendar
const Calendar = () => import(/* webpackChunkName: "extra" */ '@/views/Calendar/Calendar.vue');
// Charts
const Charts = () => import(/* webpackChunkName: "dashboard" */ '@/views/Charts.vue');

// Components pages
const Buttons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Buttons.vue');
const Cards = () => import(/* webpackChunkName: "components" */ '@/views/Components/Cards.vue');
const GridSystem = () => import(/* webpackChunkName: "components" */ '@/views/Components/GridSystem.vue');
const Notifications = () => import(/* webpackChunkName: "components" */ '@/views/Components/Notifications.vue');
const Icons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Icons.vue');
const Typography = () => import(/* webpackChunkName: "components" */ '@/views/Components/Typography.vue');
const NestedSorting = () => import(/* webpackChunkName: "components" */ '@/views/Components/NestedSorting.vue');

// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const AlternativeDashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/AlternativeDashboard.vue');
const Widgets = () => import(/* webpackChunkName: "dashboard" */ '@/views/Widgets.vue');

// Forms pages
const FormElements = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormElements.vue');
const FormComponents = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormComponents.vue');
const FormValidation = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormValidation.vue');

// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/GoogleMaps.vue');
const VectorMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/VectorMaps.vue');

// Pages
const User = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserProfile.vue');
const Pricing = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Pricing.vue');
const TimeLine = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/TimeLinePage.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Home = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');
const Register = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Register.vue');
const Lock = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Lock.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/RegularTables.vue');
const SortableTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/SortableTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/PaginatedTables.vue');

// Setup pages
const Users = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/UsersFolder/Users.vue');
const AddUsers = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/UsersFolder/AddUsers.vue');
const EditUsers = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/UsersFolder/EditUsers.vue');
const MyUserProfile = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/UsersFolder/UserProfile/MyUserProfile.vue');

const VariableExpense = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/VariableExpenseFolder/VariableExpense.vue');
const AddVariableExpense = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/VariableExpenseFolder/AddVariableExpense.vue');
const EditVariableExpense = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/VariableExpenseFolder/EditVariableExpense.vue');

// Financial Proposal pages
const FinancialProposal = () => import(/* webpackChunkName: "tables" */ '@/views/FinancialProposal/FinancialProposal.vue');
const FinancialProposalDemo = () => import(/* webpackChunkName: "tables" */ '@/views/FinancialProposal/demo/FinancialProposalDemo.vue');
const FinancialProposalReportLog = () => import(/* webpackChunkName: "tables" */ '@/views/FinancialProposal/CustomerFinancialProposalFolder/FinancialProposalReportLog.vue');
const CustomerFinancialProposal = () => import(/* webpackChunkName: "tables" */ '@/views/FinancialProposal/CustomerFinancialProposalFolder/CustomerFinancialProposal.vue');
const PdfDownloadReports = () => import(/* webpackChunkName: "tables" */ '@/views/FinancialProposal/PdfDownloadReportsFolder/PdfDownloadReports.vue');
const PdfDownloadReportLog = () => import(/* webpackChunkName: "tables" */ '@/views/FinancialProposal/PdfDownloadReportsFolder/PdfDownloadReportLog.vue');

const PendingAcceptance = () => import(/* webpackChunkName: "tables" */ '@/views/PendingAcceptance/PendingAcceptanceListing.vue');
const PendingCustomerDetail = () => import(/* webpackChunkName: "tables" */ '@/views/CustomerProfile/PendingCustomerDetail.vue');
const CustomerDetail = () => import(/* webpackChunkName: "tables" */ '@/views/CustomerProfile/CustomerDetail.vue');

const AllCustomer = () => import(/* webpackChunkName: "tables" */ '@/views/AllCustomers/AllCustomerListing.vue');

const CreditLoanCase = () => import(/* webpackChunkName: "tables" */ '@/views/CreditLoanCase/CaseListing.vue');
const CreditLoanCaseDetail = () => import(/* webpackChunkName: "tables" */ '@/views/CreditLoanCase/CaseDetail/CaseDetail.vue');

const CreditLoanDisbursement = () => import(/* webpackChunkName: "tables" */ '@/views/CreditLoanDisbursement/DisbursementListing.vue');

const CreditLoanCollection = () => import(/* webpackChunkName: "tables" */ '@/views/CreditLoanCollection/CollectionListing.vue');

const FundsMgmtAnalysis = () => import(/* webpackChunkName: "tables" */ '@/views/FundsMgmtAnalysis/Analysis.vue');


const FundsMgmtInvestors = () => import(/* webpackChunkName: "tables" */ '@/views/FundsMgmtInvestors/InvestorsListing.vue');
const FundsMgmtInvestorsDetail = () => import(/* webpackChunkName: "tables" */ '@/views/FundsMgmtInvestors/InvestorDetails/InvestorDetails.vue');

const FundsMgmtReferral = () => import(/* webpackChunkName: "tables" */ '@/views/FundsMgmtReferral/ReferralListing.vue');

const FundsMgmtCashflow = () => import(/* webpackChunkName: "tables" */ '@/views/FundsMgmtCashflow/Cashflow.vue');

const FundsMgmtApproval = () => import(/* webpackChunkName: "tables" */ '@/views/FundsMgmtPaymentApproval/PaymentApprovalListing.vue');

const PendingProposal = () => import(/* webpackChunkName: "tables" */ '@/views/PendingProposal/PendingProposalListing.vue');

const AllSettings = () => import(/* webpackChunkName: "tables" */ '@/views/AllSettings/AllSettings.vue');
const AllTemplates = () => import(/* webpackChunkName: "tables" */ '@/views/AllSettings/AllTemplates.vue');
const AllStatus = () => import(/* webpackChunkName: "tables" */ '@/views/AllSettings/AllStatus.vue');
const StatusSettings = () => import(/* webpackChunkName: "tables" */ '@/views/StatusSettings/StatusSettings.vue');

const Reporting = () => import(/* webpackChunkName: "tables" */ '@/views/Reporting/Reporting.vue');
const AgedReceivableReport = () => import(/* webpackChunkName: "tables" */ '@/views/Reporting/FinancialReports/AgedReceivable.vue');

const LmsDashboard = () => import(/* webpackChunkName: "tables" */ '@/views/Dashboard/LmsDashboard.vue');


//TEMPLATE ROUTE

// let componentsMenu = {
//   path: '/components',
//   component: DashboardLayout,
//   redirect: '/components/buttons',
//   name: 'Components',
//   children: [
//     {
//       path: 'buttons',
//       name: 'Buttons',
//       component: Buttons
//     },
//     {
//       path: 'cards',
//       name: 'Cards',
//       component: Cards
//     },
//     {
//       path: 'grid-system',
//       name: 'Grid System',
//       component: GridSystem
//     },
//     {
//       path: 'notifications',
//       name: 'Notifications',
//       component: Notifications
//     },
//     {
//       path: 'icons',
//       name: 'Icons',
//       component: Icons
//     },
//     {
//       path: 'typography',
//       name: 'Typography',
//       component: Typography
//     },
//     {
//       path: 'nested-sorting',
//       name: 'Nested Sorting',
//       component: NestedSorting
//     }
//   ]
// };

// let formsMenu = {
//   path: '/forms',
//   component: DashboardLayout,
//   redirect: '/forms/elements',
//   name: 'Forms',
//   children: [
//     {
//       path: 'elements',
//       name: 'Form elements',
//       component:  FormElements
//     },
//     {
//       path: 'components',
//       name: 'Form components',
//       component:  FormComponents
//     },
//     {
//       path: 'validation',
//       name: 'Form validation',
//       component:  FormValidation
//     }
//   ]
// };

// let tablesMenu = {
//   path: '/tables',
//   component: DashboardLayout,
//   redirect: '/table/regular',
//   name: 'Tables menu',
//   children: [
//     {
//       path: 'regular',
//       name: 'Tables',
//       component: RegularTables
//     },
//     {
//       path: 'sortable',
//       name: 'Sortable',
//       component: SortableTables
//     },
//     {
//       path: 'paginated',
//       name: 'Paginated Tables',
//       component: PaginatedTables
//     }
//   ]
// };

// let mapsMenu = {
//   path: '/maps',
//   component: DashboardLayout,
//   name: 'Maps',
//   redirect: '/maps/google',
//   children: [
//     {
//       path: 'google',
//       name: 'Google Maps',
//       component: GoogleMaps
//     },
//     {
//       path: 'vector',
//       name: 'Vector Map',
//       component: VectorMaps
//     }
//   ]
// };

// let pagesMenu = {
//   path: '/pages',
//   component: DashboardLayout,
//   name: 'Pages',
//   redirect: '/pages/user',
//   children: [
//     {
//       path: 'user',
//       name: 'User Page',
//       component: User
//     },
//     {
//       path: 'timeline',
//       name: 'Timeline Page',
//       component: TimeLine
//     }
//   ]
// };

//APP ROUTE

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    // {
    //   path: '/home',
    //   name: 'Home',
    //   component: Home,
    //   meta: {
    //     noBodyBackground: true
    //   }
    // },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing
    },
    {
      path: '/lock',
      name: 'Lock',
      component: Lock
    },
    { path: '*', component: NotFound }
  ]
};

let setupMenu = {
  path: '/setup',
  component: DashboardLayout,
  redirect: '/setup/users',
  name: 'Setup menu',
  children: [
    {
      path: 'users',
      name: 'Users',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: Users,
    },
    {
      path: 'addUsers',
      name: 'Add Users',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: AddUsers,
    },
    {
      path: 'editUsers/:id',
      name: 'Edit Users',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: EditUsers,
    },
    {
      path: 'my_profile',
      name: 'My Profile',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: MyUserProfile,
    },
    {
      path: 'variable_expense',
      name: 'Variable Expense',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: VariableExpense,
    },
    {
      path: 'addVariableExpense',
      name: 'Add Variable Expense',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: AddVariableExpense,
    },
    {
      path: 'editVariableExpense/:id',
      name: 'Edit Variable Expense',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: EditVariableExpense,
    },
    {
      path: '/setup/settings',
      name: 'All Settings',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: AllSettings,
    },
    {
      path: '/setup/templates',
      name: 'All Template',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: AllTemplates,
    },
    {
      path: '/setup/statuses',
      name: 'All Status',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: AllStatus,
    },
    {
      path: '/setup/status-settings/:module',
      name: 'Status Settings',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: StatusSettings,
    },
  ]
};

let generalMenu = {
  path: '/home',
  component: DashboardLayout,
  name: 'Home',
  children: [
    {
      path: '/home',
      name: 'Welcome Page',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: Home,
    },
  ]
};
let dashboardMenu = {
  path: '/dashboard',
  component: DashboardLayout,
  name: 'LMS Dashboard',
  children: [
    {
      path: '/dashboard/lms',
      name: 'Dashboard LMS',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: LmsDashboard,
    },
  ]
};
let creditLoanCaseMenu = {
  path: '/credit_loan_case',
  component: DashboardLayout,
  name: 'Credit Loan Case Menu',
  children: [
    {
      path: '/credit-loan-case/detail/:case_id',
      name: 'Credit Loan Case Detail',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: CreditLoanCaseDetail,
    },
    {
      path: '/credit-loan-case/all-case',
      name: 'Credit Loan Case',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: CreditLoanCase,
    },
    {
      path: '/credit-loan-case/all-case-disbursement',
      name: 'Credit Loan Case Disbursement',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: CreditLoanDisbursement,
    },
    {
      path: '/credit-loan-case/all-case-collection',
      name: 'Credit Loan Case Collection',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: CreditLoanCollection,
    },
  ]
}

let reportingMenu = {
  path: '/reporting',
  component: DashboardLayout,
  name: 'Pending Proposal Menu',
  children: [
    {
      path: '/reporting',
      name: 'Reporting',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: Reporting,
    },
    {
      path: '/reporting/aged_receivable',
      name: 'Aged Receivable Report',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: AgedReceivableReport,
    },
  ]
};

let fundsManagementMenu  = {
  path: '/funds_management',
  component: DashboardLayout,
  name: 'Funds Management Menu',
  children: [
    {
      path: '/funds_management/analysis',
      name: 'Funds Management Analysis',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: FundsMgmtAnalysis,
    },
    {
      path: '/funds_management/investors_profile',
      name: 'Funds Management Investors Profile',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: FundsMgmtInvestors,
    },
    {
      path: '/funds_management/investors_profile/detail',
      name: 'Funds Management Investors Profile Detail',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: FundsMgmtInvestorsDetail,
    },
    {
      path: '/funds_management/referral_fee',
      name: 'Funds Management Referral Fee',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: FundsMgmtReferral,
    },
    {
      path: '/funds_management/cashflow',
      name: 'Funds Management Cashflow',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: FundsMgmtCashflow,
    },
    {
      path: '/funds_management/payment_approval',
      name: 'Funds Management Payment Approval',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: FundsMgmtApproval,
    },
  ]
}

let customersListMenu = {
  path: '/customers-list',
  component: DashboardLayout,
  name: 'Customer Menu',
  children: [
    {
      path: '/customers-list/pending-acceptance',
      name: ' Pending Acceptance',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: PendingAcceptance,
    },
    {
      path: '/customers-list/pending-proposal',
      name: ' Pending Proposal',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: PendingProposal,
    },
    {
      path: '/customers-list/all-customer',
      name: ' All Customer',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: AllCustomer,
    },
  ]
};

let customerDetailMenu = {
  path: '/customer',
  component: DashboardLayout,
  name: 'Customer Detail Menu',
  children: [
    {
      path: '/customer/pending-customer-detail/:cust_id',
      name: ' Pending Acceptance Detail',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: PendingCustomerDetail,
    },
    {
      path: '/customer/customer-detail/:cust_id',
      name: ' All Customer Detail',
      meta : { 
				requiresAuth: true,
				hasAccess:[]
			},
      component: CustomerDetail,
    },
  ]
};

const routes = [
  {
    path: '/',
    redirect: '/home',
		meta : { 
			requiresAuth: true
		},
    name: 'Root'
  },
  // componentsMenu,
  // formsMenu,
  // tablesMenu,
  // mapsMenu,
  // pagesMenu,
	generalMenu,
  setupMenu,
  reportingMenu,
  creditLoanCaseMenu,
  fundsManagementMenu,
  customersListMenu,
  customerDetailMenu,
  dashboardMenu,
  // {
  //   path: '/',
  //   component: DashboardLayout,
  //   redirect: '/dashboard',
  //   name: 'Dashboard layout',
  //   children: [
  //     {
  //       path: 'dashboard',
  //       name: 'Dashboard',
  //       component: Dashboard
  //     },
  //     {
  //       path: 'alternative',
  //       name: 'Alternative',
  //       component: AlternativeDashboard,
  //       meta: {
  //         navbarType: 'light'
  //       }
  //     },
  //     {
  //       path: 'calendar',
  //       name: 'Calendar',
  //       component: Calendar
  //     },
  //     {
  //       path: 'charts',
  //       name: 'Charts',
  //       component: Charts
  //     },
  //     {
  //       path: 'widgets',
  //       name: 'Widgets',
  //       component: Widgets
  //     }
  //   ]
  // },
  authPages,
];

export default routes;
